module.exports = {
	"textures": [
		{
			"image": "iosHelp",
			"format": "RGBA8888",
			"size": {
				"w": 733,
				"h": 398
			},
			"scale": 1,
			"frames": [
				{
					"filename": "iosMenu.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 300,
						"h": 340
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 300,
						"h": 340
					},
					"frame": {
						"x": 2,
						"y": 2,
						"w": 300,
						"h": 340
					}
				},
				{
					"filename": "iosTab.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 729,
						"h": 50
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 729,
						"h": 50
					},
					"frame": {
						"x": 2,
						"y": 346,
						"w": 729,
						"h": 50
					}
				}
			]
		}
	],
	"meta": {
		"app": "http://free-tex-packer.com",
		"version": "0.6.7"
	}
};